import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { Dialog, DialogContent } from "@mui/material";
import { reactIcons } from "../../utils/icons";

const ImagePreviewModal = ({
  viewImage,
  ClosedImageView,
  imageUrl,
  setViewImage
}) => {
  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event.key === "Escape" && event.keyCode === 27) {
        setViewImage(false);
      }
    };
    if (viewImage) {
      document.addEventListener("keyup", handleKeyPress);
    } else {
      document.removeEventListener("keyup", handleKeyPress);
    }

    return () => {
      document.removeEventListener("keyup", handleKeyPress);
    };
    //eslint-disable-next-line
  }, [viewImage]);
  return (
    <Dialog open={viewImage}>
      <div className="bg-blue-700 w-full ">
        <div className="flex justify-end rounded-full">
          <span
            className="cursor-pointer text-[24px] text-white"
            onClick={ClosedImageView}
          >
            {reactIcons.close}
          </span>
        </div>
      </div>
      <DialogContent>
        <div className="relative w-full max-w-sm mx-auto shadow-md rounded-b-lg bg-white px-4 py-4">
          <img src={imageUrl} alt="image" />
        </div>
      </DialogContent>
    </Dialog>
  );
};
ImagePreviewModal.propTypes = {
  viewImage: PropTypes.bool.isRequired,
  ClosedImageView: PropTypes.func.isRequired,
  imageUrl: PropTypes.string.isRequired,
  setViewImage: PropTypes.func.isRequired
};
export default ImagePreviewModal;
